/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type StorefrontDetails_seller$ref = any;
type StorefrontFollowButton_seller$ref = any;
type StorefrontSocial_seller$ref = any;
export type StorefrontHead_seller$ref = any;
export type StorefrontHead_seller = {
    readonly serviceId: string | null;
    readonly favoritesByUser?: ReadonlyArray<{
        readonly serviceId: string | null;
    } | null> | null;
    readonly sellerProfile: {
        readonly company: string | null;
    } | null;
    readonly storefrontProfile: {
        readonly aboutUs: string | null;
        readonly photos: ReadonlyArray<{
            readonly path: string | null;
            readonly type: {
                readonly name: string | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $fragmentRefs": StorefrontFollowButton_seller$ref & StorefrontSocial_seller$ref & StorefrontDetails_seller$ref;
    readonly " $refType": StorefrontHead_seller$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "StorefrontHead_seller",
        "type": "Seller",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "userId",
                "type": "String!"
            },
            {
                "kind": "RootArgument",
                "name": "hasUserId",
                "type": "Boolean"
            },
            {
                "kind": "RootArgument",
                "name": "storefrontId",
                "type": "Int"
            }
        ],
        "selections": [
            (v0 /*: any*/),
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "sellerProfile",
                "storageKey": null,
                "args": null,
                "concreteType": "SellerProfile",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "company",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "storefrontProfile",
                "storageKey": null,
                "args": [
                    {
                        "kind": "Variable",
                        "name": "storefrontId",
                        "variableName": "storefrontId"
                    }
                ],
                "concreteType": "StorefrontProfile",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "aboutUs",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "photos",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Photo",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "path",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "type",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "PhotoType",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "name",
                                        "args": null,
                                        "storageKey": null
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "hasUserId",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "favoritesByUser",
                        "storageKey": null,
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "userIds",
                                "variableName": "userId"
                            }
                        ],
                        "concreteType": "Favorite",
                        "plural": true,
                        "selections": [
                            (v0 /*: any*/)
                        ]
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "StorefrontFollowButton_seller",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "StorefrontSocial_seller",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "StorefrontDetails_seller",
                "args": null
            }
        ]
    } as any;
})();
(node as any).hash = '8410b4c5969fc0c58bc5ae655cf0bf67';
export default node;
